import { formatDate, MOMENT_FORMATS } from '../../../../utils/dateFormat';
import { formatEventTimeRange } from '../eventTimeUtils';

export const formatConfirmationDate = (date) => formatDate(date, MOMENT_FORMATS.DATE_LONG) || '—';

export const formatTimeRangeDisplay = (startTime, endTime) => {
  const range = formatEventTimeRange(startTime, endTime);
  return range || '—';
};

export const formatCapacity = (totalSeats) => {
  if (!totalSeats) return '—';
  const n = Number(totalSeats);
  if (Number.isNaN(n)) return totalSeats;
  return `${n} ${n === 1 ? 'Person' : 'People'}`;
};

export const formatPrice = (price) => {
  if (!price) return '—';
  const trimmed = String(price).trim();
  if (/AED/i.test(trimmed)) return trimmed;
  return `${trimmed} AED`;
};
